import { Controller } from "react-hook-form";
import { Button, Col, Label, Row } from "reactstrap";
import { SelectionField, TextAreaField } from "../../../CommonElements";
import { Link } from "react-router-dom";
import { isIndividu } from "../constants";

const FormAssessmentLayout = ({
  formQuestions,
  control,
  otherData,
  selectedUnitKerja,
  type,
  pendingSubmit,
  featureDisabled,
}) => {
  return (
    <>
      {formQuestions.map((question) => (
        <Col className={"py-2"}>
          <Label>
            <strong>{question.category}</strong>
          </Label>
          {question.questions.map((row) => (
            <Controller
              name={row.name}
              control={control}
              render={({ field, fieldState }) => (
                <Row>
                  <Col>{row.label}</Col>
                  <Col className={"col-6"}>
                    <SelectionField
                      className={"m-0"}
                      placeholder={"Pilih"}
                      options={otherData?.predikat?.map((predikat) => ({
                        id: predikat.id,
                        name: predikat.predikat,
                      }))}
                      optionStyle={[
                        { backgroundColor: "#E1EBFC" },
                        { backgroundColor: "#9DBDF5" },
                      ]}
                      fieldState={fieldState}
                      {...field}
                      disabled={!isIndividu(type) && !selectedUnitKerja}
                    />
                  </Col>
                </Row>
              )}
            />
          ))}
        </Col>
      ))}
      <Col>
        <Label>{ type === "individu" ? "Kebutuhan Pengembangan Diri" : "Kebutuhan Pengembangan"}</Label>
        <Controller
          name={"kebutuhan_pengembangan"}
          control={control}
          render={({ field, fieldState }) => (
            <TextAreaField
              placeholder={"misal: mohon diadakan cabil setahun sekali"}
              fieldState={fieldState}
              {...field}
            />
          )}
        />
      </Col>

      <div className="d-flex justify-content-between flex-row-reverse">
        <Button
          color={"primary"}
          type="submit"
          disabled={
            featureDisabled ||
            (!isIndividu(type) && !selectedUnitKerja) ||
            pendingSubmit
          }
        >
          Simpan
        </Button>
        <Link to={`/dashboard`}>
          <Button>Kembali ke Dashboard</Button>
        </Link>
      </div>
    </>
  );
};

export default FormAssessmentLayout;
